<template>
  <div class="mt-3 mt-md-0">
    <div class="intro-banner text-white text-xl">
      <p>溫馨提醒</p>
    </div>
    <div class="intro-text bg-white p-4 text-lg" v-if="$route.name === 'ai_assistantMain' && aiType === 'letter'">
      <p><span class="title">步驟說明：</span>請先填寫寄件人與收件人資訊，再輸入信件資訊。</p>
      <p><span class="title">定義內容：</span>AI 小幫手生成後，您可依據實際使用需求，進一步針對細部書信內容調整。</p>
      <p><span class="title">重視隱私與安全：</span>在輸入資訊時，請謹慎不要透露自己或他人的個資或私人資訊。</p>
      <p><span class="title">再次核對：</span>本篇商用日文書信為 AI 小幫手自動生成，建議使用前再次斟酌核對相關細節。</p>
    </div>
    <div class="intro-text bg-white p-4 text-lg" v-if="$route.name === 'ai_assistantMain' && aiType === 'speech'">
      <p><span class="title">步驟說明：</span>請先填寫主題、對象資訊，再輸入內容簡述。</p>
      <p><span class="title">定義內容：</span>AI 小幫手生成後，您可依據實際使用需求，進一步針對細部講稿內容調整。</p>
      <p><span class="title">重視隱私與安全：</span>在輸入資訊時，請謹慎不要透露自己或他人的個資或私人資訊。</p>
      <p><span class="title">再次核對：</span>本篇日文演講稿為 AI 小幫手自動生成，建議使用前再次斟酌核對相關細節。</p>
    </div>
    <!-- 口說 -->
    <div class="intro-text bg-white p-4 text-lg" v-if="$route.name === 'chat'">
      <h6 class="font-bold text-lg">操作說明：</h6>
      <p class="mb-2">1. 點<img src="@/assets/image/ai/mic_C.png" alt="" class="d-inline-block icon-img mx-1">說出回應的句子，再點<img src="@/assets/image/ai/submit_icon.png" alt="" class="d-inline-block icon-img mx-1">，送出回應。</p>
      <p class="mb-2">2. 點<img src="@/assets/image/ai/AI_A.png" alt="" class="d-inline-block icon-img mx-1">參考 AI 回應內容，並練習說說看。</p>
      <p class="mb-2">3. 點<img src="@/assets/image/ai/translate_btn_off.png" alt="" class="d-inline-block icon-img mx-1">輸入想翻譯的中文。</p>
      <p class="mb-2">4. 點<img src="@/assets/image/ai/btn_AItalk_voice.png" alt="" class="d-inline-block icon-img mx-1">聆聽自己的錄音。</p>
      <p class="mb-2">5. 點<img src="@/assets/image/ai/btn_AItalk_correct.png" class="d-inline-block icon-img mx-1">觀看 AI 反饋建議，讓自己下次說得更好。</p>
      <p class="mb-2">6. 若 AI 回應不符預期，請修改文字內容或點擊重新整理。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rule',
  props: {
    aiType: {
      type: String,
      default: 'letter'
    }
  }
}
</script>
<style lang="scss" scoped>
  .intro-banner {
    padding-top: 5rem;
    padding-bottom: 5rem;
    background: #0E103E;
    text-align: center;
    font-weight: 700;
    background-image:
      url('~@/assets/image/ai/plusSS.png'), url('~@/assets/image/ai/plusSS.png'),
      url('~@/assets/image/ai/plusS.png'), url('~@/assets/image/ai/plusS.png'),
      url('~@/assets/image/ai/plusB.png'), url('~@/assets/image/ai/plusB.png'),
      url('~@/assets/image/ai/robotL.png'), url('~@/assets/image/ai/robotR.png');
    background-repeat: no-repeat;
    background-position:
      left 18% top 15%, right 18% top 15%,
      left 6% top 30%, right 6% top 30%,
      left 13% top 55%, right 13% top 55%,
      left 10% bottom 0%, right 5% bottom 0%;
    p {
      margin: 0;
    }
    @media (max-width: 1024px) {
      font-size: 1.125rem;
    }
  }
  .intro-text{
    h6 {
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
    p {
      margin-bottom: 1.25rem;
      line-height: 150%;
      font-weight: 500;
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
    .title {
      font-weight: 700;
    }
    .icon-img {
      max-width: 1.5em;
      height: auto;
      object-fit: contain;
    }
  }
</style>
